var map = {
	"./00103.svg": 4745,
	"./011.svg": 2437,
	"./023.svg": 1321,
	"./032.svg": 4999,
	"./033.svg": 4493,
	"./035.svg": 9319,
	"./035A.svg": 1570,
	"./044.svg": 1823,
	"./050.svg": 7833,
	"./057.svg": 7675,
	"./058.svg": 635,
	"./068.svg": 6906,
	"./070.svg": 3188,
	"./076.svg": 7497,
	"./082.svg": 7402,
	"./100.svg": 9310,
	"./102.svg": 9083,
	"./104.svg": 4710,
	"./125.svg": 4539,
	"./2.svg": 8793,
	"./214.svg": 2316,
	"./215.svg": 9082,
	"./221.svg": 9944,
	"./232.svg": 2888,
	"./3.svg": 2415,
	"./301.svg": 3418,
	"./302.svg": 9029,
	"./401.svg": 5446,
	"./50211.svg": 5570,
	"./50823.svg": 3699,
	"./51211.svg": 3266,
	"./51310.svg": 6828,
	"./562.svg": 7743,
	"./600.svg": 5591,
	"./Beginner.svg": 4223,
	"./Disciple Cover On Display.svg": 4184,
	"./Enterprise bank.svg": 7384,
	"./GHS.svg": 4949,
	"./Giftcards.svg": 599,
	"./Group 162497.svg": 7736,
	"./Group 162893.svg": 5111,
	"./Group 163189.svg": 995,
	"./Group 163221.svg": 5664,
	"./Group 163222.svg": 8123,
	"./Group 163282.svg": 3669,
	"./Group 163290.svg": 8849,
	"./Group 163389.svg": 3583,
	"./Group 163392.svg": 1226,
	"./Group 163393.svg": 9239,
	"./Group 163394.svg": 6773,
	"./Group 163431.svg": 6256,
	"./Group 3256.svg": 5535,
	"./Group 3280.svg": 4024,
	"./Group-162497.svg": 9217,
	"./Group-162704.svg": 9849,
	"./Group-162718.svg": 6570,
	"./Group-162732.svg": 2198,
	"./Gtbank.svg": 873,
	"./KES.svg": 3860,
	"./Kuda bank.svg": 7780,
	"./Mainstreet bank.svg": 2915,
	"./Mask Group 46.svg": 5584,
	"./Mask Group lg.svg": 5785,
	"./Mask Group sm.svg": 2254,
	"./Master Cover On Display.svg": 4951,
	"./Notification Bell.svg": 7947,
	"./PMT_M131_010.svg": 9955,
	"./Path 5455.svg": 1356,
	"./Product-Icons.svg": 6692,
	"./Rectangle 147825.svg": 8222,
	"./Rectangle 147826.svg": 5216,
	"./Rectangle 147827.svg": 3638,
	"./Rectangle 147828.svg": 9824,
	"./Redem-Logo.svg": 3151,
	"./Spinner.svg": 1308,
	"./Web-Icons/Bestbuy.svg": 700,
	"./Web-Icons/Footlocker.svg": 3424,
	"./Web-Icons/Gamestop.svg": 6395,
	"./Web-Icons/JCPenney.svg": 2504,
	"./Web-Icons/Nike.svg": 5030,
	"./Web-Icons/Nordstrom.svg": 9888,
	"./Web-Icons/SamClub.svg": 9009,
	"./Web-Icons/Sephora.svg": 7318,
	"./Web-Icons/Target.svg": 7915,
	"./Web-Icons/Visa.svg": 313,
	"./Web-Icons/Walmart.svg": 8509,
	"./airtime.svg": 7896,
	"./amazon-icon-1.svg": 8120,
	"./apple-13.svg": 2126,
	"./apple.svg": 1060,
	"./arrow-down.svg": 9680,
	"./bills.svg": 9258,
	"./branch.svg": 407,
	"./calculator-svgrepo-com.svg": 5224,
	"./caret-up.svg": 2737,
	"./checked.svg": 6724,
	"./crown.svg": 6287,
	"./danger.svg": 1545,
	"./data.svg": 841,
	"./dummy-img.svg": 4855,
	"./ebay.svg": 4549,
	"./electricity.svg": 6346,
	"./fire (1) (1).svg": 791,
	"./fire.svg": 8325,
	"./house.svg": 7155,
	"./ic_close_24px.svg": 6245,
	"./ic_info_outline_24px.svg": 7452,
	"./ic_keyboard_arrow_down_24px.svg": 3608,
	"./ic_keyboard_arrow_left_24px.svg": 9822,
	"./ic_keyboard_arrow_right_24px (1).svg": 8292,
	"./ic_keyboard_arrow_right_24px-1.svg": 8925,
	"./ic_keyboard_arrow_right_24px.svg": 6050,
	"./info-icon.svg": 9086,
	"./macys-logo-1.svg": 7820,
	"./money-bag.svg": 3549,
	"./notification-bell2.svg": 9187,
	"./playstore.svg": 2570,
	"./screenshot.svg": 6538,
	"./star.svg": 6028,
	"./steam-1.svg": 7030,
	"./subscription.svg": 7457,
	"./success.svg": 2932,
	"./successful-tick.svg": 9170,
	"./switch.svg": 8815,
	"./telescope.svg": 441,
	"./toll_gate.svg": 3349,
	"./trophy-svgrepo-com.svg": 4023,
	"./tv_bills.svg": 3945,
	"./upload-dummy.svg": 3197,
	"./wallet.svg": 1491,
	"./xbox-1.svg": 4102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1838;